import { render, staticRenderFns } from "./e-mail-card.vue?vue&type=template&id=4ab3dec1&scoped=true"
import script from "./e-mail-card.vue?vue&type=script&lang=ts"
export * from "./e-mail-card.vue?vue&type=script&lang=ts"
import style0 from "./e-mail-card.vue?vue&type=style&index=0&id=4ab3dec1&prod&lang=stylus&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4ab3dec1",
  null
  
)

export default component.exports